const navbarAll = "#ffffff"
const darkAll = "#000000"
const secondColorAll = "#27b88b"


export const header = "#012a45";
// export const navbar = "#000000";
// export const lightText = "#4f4c4c";
export const darkText = "#000000";
export const lightButton = "#eeecff";
export const darkButton = "#cf2727";
export const dimBackground = "#e6e3e3";
export const lightBackground = "#022066";
export const darkBackground = "#ffffff";
export const white = "#ffffff";
export const black = "#1a2131";

//theme color for Brand Invoice

export const currency = "GBP"; //USD , GBP
export const brandName = "British Assignments";
export const brandUrl = "britishassignments.co.uk";
// export const navbar = "linear-gradient(45deg,#ffc600 1%,#ff6c00 100%)";
export const navbar = "#cd2826";
export const navbarText = darkAll;
export const lightText = "#ACACAC";
export const mainBackgound = darkAll;
export const invoiceCard = "#377fd3";
export const button = "#FD0003";
export const cardBackground = "#f3f3f5";
export const lightBorder = "#E2E2E2";
export const darkGradient = "linear-gradient(135deg,rgb(226, 32, 45) 5%,rgb(95, 93, 238) 100%)";
// export const darkGradient = "#022066";



// 002e47